export const CONTACT = {
  name: "AUS/SIGNS",
  phone: "0427 197 418",
  phoneRaw: "0427197418",
  hours: [
    { day: "Mon – Fri", time: "7:00 AM – 5:00 PM" },
    { day: "Saturday", time: "8:00 AM – 12:00 PM" },
    { day: "Sunday", time: "Closed" },
  ],
  area: "Servicing Australia Wide",
  mapQuery: "Australia",
};

export const SERVICES = [
  {
    key: "end-tipper",
    title: "End Tipper Trailer Signage",
    blurb: "Purpose-built branding engineered for the roughest end tipper operations.",
    items: ["Fleet branding", "Company logos", "Reflective safety markings", "Full trailer wraps"],
    image: "https://images.pexels.com/photos/27099095/pexels-photo-27099095.jpeg",
  },
  {
    key: "commercial",
    title: "Commercial Vehicle Signage",
    blurb: "From a single ute to an entire heavy vehicle fleet, branded to standard.",
    items: ["Utes", "Trucks", "Vans", "Prime movers", "Machinery", "Fleet graphics"],
    image: "https://images.pexels.com/photos/6563903/pexels-photo-6563903.jpeg",
  },
  {
    key: "building",
    title: "Building Signage",
    blurb: "Sharp window decals and premium ACM panel signage that lift any shopfront or facade.",
    items: ["ACM panel signs", "Window decals", "Frosted window graphics", "Shopfront signage", "Illuminated signs", "Directory & tenancy signs"],
    image: "https://images.unsplash.com/photo-1564419965579-5da68ffdf3af",
  },
  {
    key: "banners",
    title: "Banners",
    blurb: "Heavy-duty banners built to survive Australian sites and weather.",
    items: ["Construction fence banners", "Event banners", "Mesh banners", "Pull-up banners", "Promotional signage"],
    image: "https://images.pexels.com/photos/36398150/pexels-photo-36398150.jpeg",
  },
];

export const WHY = [
  { title: "Premium Materials", desc: "Only cast vinyls and grade-A substrates built to last." },
  { title: "Precision Installation", desc: "Bubble-free, panel-perfect application, every time." },
  { title: "Fast Turnaround", desc: "Minimise downtime — we work to your schedule." },
  { title: "Australia Wide", desc: "Mobile install teams servicing sites nationwide." },
  { title: "Commercial Specialists", desc: "Transport, construction and trade fleets are our focus." },
  { title: "Competitive Pricing", desc: "Sharp quotes without cutting corners on quality." },
];

export const PROCESS = [
  { n: "01", title: "Request a Quote", desc: "Tell us about your vehicles or building." },
  { n: "02", title: "Design Approval", desc: "We mock it up — you sign off on the look." },
  { n: "03", title: "Print Production", desc: "Printed on premium materials in-house." },
  { n: "04", title: "Professional Installation", desc: "Expertly fitted by our install crews." },
  { n: "05", title: "Enjoy Your Branding", desc: "Roll out looking sharp and get seen." },
];

export const TESTIMONIALS = [
  { quote: "AUS/SIGNS completely transformed our fleet. Professional from start to finish.", author: "Fleet Manager", role: "Civil Contracting" },
  { quote: "Our trailers stand out everywhere they go.", author: "Owner", role: "Transport Company" },
  { quote: "Excellent workmanship and quick turnaround.", author: "Operations Lead", role: "Earthmoving" },
];

export const INDUSTRIES = [
  "Transport", "Logistics", "Trade Businesses", "Manufacturing",
];

export const PORTFOLIO_CATEGORIES = [
  "All", "End Tippers", "Fleet Branding", "Building Signage",
];

export const SIGNAGE_TYPES = [
  "End Tipper Trailer Signage", "Commercial Vehicle Signage", "Building Signage", "Banners", "Full Fleet Branding", "Other",
];

export const VEHICLE_TYPES = [
  "End Tipper Trailer", "Prime Mover", "Semi Trailer", "Truck", "Ute", "Van", "Machinery", "N/A – Building Signage",
];
